import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import './Button.module.scss'

const Button = ({ children, type, disabled, click }) => (
  <button
    id='button'
    styleName={classnames('button', { [type]: type })}
    disabled={disabled}
    onClick={() => click()}
  >
    <span>{children}</span>
  </button>
)

Button.propTypes = {
  children: PropTypes.string.isRequired,
  style: PropTypes.string,
  click: PropTypes.func
}

Button.defaultProps = {
  click: () => {}
}

export default Button



// WEBPACK FOOTER //
// ./src/components/Button/Button.js